import { FullScreenLoading } from '@/components/FullScreenLoading';
import { trackSignUpEvent } from '@/lib/analytics';
import { prepareRejudgment, toGatewayUrl } from '@/lib/auth';
import { createFileRoute } from '@tanstack/react-router';
import { useEffect } from 'react';
import { z } from 'zod';

// Kept outside /_main: the free user is already blocked and its personal tenant inactive, so
// /_main's API calls would answer 403 and log out before sign_up is sent or the invitation opened.
export const Route = createFileRoute('/upgrade/completed')({
  validateSearch: z.object({ invitation: z.string().optional() }),
  // A route without beforeLoad or loader renders before its context is set.
  beforeLoad: () => ({}),
  component: Component,
});

function Component() {
  const { auth, userInfo } = Route.useRouteContext();
  const { invitation } = Route.useSearch();

  useEffect(() => {
    const invitationUrl = toGatewayUrl(invitation);
    // Without an invitation the user already belongs to the paid issuer, so log out and
    // re-judge the issuer.
    if (!invitationUrl) {
      prepareRejudgment(userInfo.email);
    }
    void trackSignUpEvent('sign_up', 'upgrade', userInfo).then(() => {
      if (invitationUrl) {
        window.location.assign(invitationUrl);
      } else {
        auth.logout({ logoutParams: { returnTo: window.location.origin } });
      }
    });
  }, []);

  return <FullScreenLoading />;
}
